import { render, staticRenderFns } from "./ChronologicalLedger.vue?vue&type=template&id=bf94b0c4&scoped=true"
import script from "./ChronologicalLedger.vue?vue&type=script&lang=js"
export * from "./ChronologicalLedger.vue?vue&type=script&lang=js"
import style0 from "./ChronologicalLedger.vue?vue&type=style&index=0&id=bf94b0c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94b0c4",
  null
  
)

export default component.exports